import HotelGallery from './HotelGallery';
export default HotelGallery;